import { Box } from "@mui/material";
import React from "react";
import LeftMargin from "./LeftMargin";
import Resource from "./Resource";
import ChangeAssignedEmployeeDialog from "./ChangeAssignedEmployeeDialog";

/**
 * @param {object} props
 * @param {import('./types').Resource[]} props.resources
 * @param {Record<string, import('./types').Appointment[]>} props.appointmentsByCalendarId
 * @param {({appointment_id: String, actual_calendar: import('./types').Resource}) => void} [props.setAssignCalendar]
 * @param {(appointment: import('./types').Appointment) => void} [props.setEditEvent]
 * @param {boolean} props.leftMargin
 */
const ResourceList = React.memo(function ResourceList({
  resources,
  setAssignCalendar,
  setEditEvent,
  appointmentsByCalendarId,
  leftMargin,
}) {
  const [changeEmployee, setChangeEmployee] = React.useState(null);

  return (
    <Box className="floor-manager-calendar" display="flex">
      {leftMargin && <LeftMargin />}
      <Box display="flex" flexGrow="1" flexShrink="1">
        {resources.length === 0 ? (
          <Resource
            resource={{ title: <>&nbsp;</> }}
            setAssignCalendar={() => {}}
            setEditEvent={() => {}}
            appointments={[]}
          />
        ) : (
          resources.map((r) => {
            return (
              <Resource
                key={r.id}
                resource={r}
                setAssignCalendar={setAssignCalendar}
                setEditEvent={setEditEvent}
                appointments={appointmentsByCalendarId[r.id] ?? []}
                setChangeEmployee={
                  setEditEvent == null ? null : setChangeEmployee
                }
              />
            );
          })
        )}
      </Box>
      {changeEmployee != null && (
        <ChangeAssignedEmployeeDialog
          appointments={changeEmployee}
          close={() => setChangeEmployee(null)}
        />
      )}
    </Box>
  );
});

export default ResourceList;
